import React, { useRef, useState } from 'react'
import InputText from '../input-text/input-text'
import inputProptypes from '../input-proptype'
import { useInitialValueToValidation } from '../custom-hooks'
import useEvents from '@components/utilities/event-hooks-utility'

import { maskPhone } from '@components/utilities/phone-number-utility'

const InputPhone = ({ value, onChange, onBlur, errorMessage, required, ...rest }) => {
  const [currentMessage, setCurrentMessage] = useState(errorMessage)
  const [inputValue, setInputValue] = useState(value || '')

  const validatePhone = maskedPhone => {
    setCurrentMessage('')
    if (!maskedPhone.length && !required) return
    if (maskedPhone.length !== 14) setCurrentMessage('O Telefone precisa ter 10 dígitos.')
  }

  const thisInput = useRef(null)
  const defaultEvents = useEvents(thisInput)

  const handleOnChange = defaultEvents.useOnChange(async ({ value, id, name }) => {
    const { maskedPhone, unmaskedPhone } = maskPhone(value)

    setInputValue(maskedPhone)
    if (onChange) await onChange({ value: unmaskedPhone, maskedValue: maskedPhone, id, name })

    return maskedPhone
  })

  const handleOnBlur = value => {
    const { maskedPhone, unmaskedPhone } = maskPhone(value)
    validatePhone(maskedPhone)
    if (onBlur) onBlur(unmaskedPhone, maskedPhone)
  }

  let inputProps = {
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    errorMessage: currentMessage,
    maxLength: 14,
    value: inputValue,
    inputRef: thisInput,
    onKeyUp: defaultEvents.onKeyUp,
    type: 'tel',
    required,
    ...rest,
  }

  useInitialValueToValidation(value, () => {
    if (!value) return
    const { maskedPhone } = maskPhone(value)

    setInputValue(maskedPhone)
    validatePhone(maskedPhone)
  })

  return <InputText {...inputProps} />
}

InputPhone.propTypes = inputProptypes

export default InputPhone
